<template>
  <div class="process" id="process">
    <div class="container process-section">
      <h1 class="section-title">{{state.translation.process.title}}</h1>
      <div class="border-cust"></div>
      <div class="row pt-5 m-0">
          <div class="col-md-12">
              <div class="main-timeline">
                  <a href="#" class="timeline">
                      <div class="timeline-icon"><awesome-icon class="icon-process" :icon="['fas', 'bullhorn']"></awesome-icon></div>
                      <div class="timeline-content">
                          <h3 class="title">{{state.translation.process.brief.title}}</h3>
                          <p class="description">
                              {{state.translation.process.brief.text}}
                          </p>
                      </div>
                  </a>
                  <a href="#" class="timeline">
                      <div class="timeline-icon"><awesome-icon class="icon-process" :icon="['fas', 'file']"></awesome-icon></div>
                      <div class="timeline-content">
                          <h3 class="title">{{state.translation.process.frd.title}}</h3>
                          <p class="description">
                              {{state.translation.process.frd.text}}
                          </p>
                      </div>
                  </a>
                  <a href="#" class="timeline">
                      <div class="timeline-icon"><awesome-icon class="icon-process" :icon="['fas', 'users']"></awesome-icon></div>
                      <div class="timeline-content">
                          <h3 class="title">{{state.translation.process.team.title}}</h3>
                          <p class="description">
                              {{state.translation.process.team.text}}
                          </p>
                      </div>
                  </a>
                  <a href="#" class="timeline">
                      <div class="timeline-icon"><awesome-icon class="icon-process" :icon="['fas', 'code']"></awesome-icon></div>
                      <div class="timeline-content">
                          <h3 class="title">{{state.translation.process.dev.title}}</h3>
                          <p class="description">
                              {{state.translation.process.dev.text}}
                          </p>
                      </div>
                  </a>
                  <a href="#" class="timeline">
                      <div class="timeline-icon"><awesome-icon class="icon-process" :icon="['fab', 'codepen']"></awesome-icon></div>
                      <div class="timeline-content">
                          <h3 class="title">{{state.translation.process.dam.title}}</h3>
                          <p class="description">
                              {{state.translation.process.dam.text}}
                          </p>
                      </div>
                  </a>
              </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Process',
  data() {
    return {
      showreel: false,
      state: this.$root.$data.state,
    }
  }
}
</script>
